import { useState, useEffect, useCallback } from 'react';
import { fetchSkillsByCategorySlug } from '../../../services/api';

const useSkillsByCategory = () => {
  const [categorySlug, setCategorySlug] = useState('');
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadSkills = useCallback(async (slug) => {
    if (!slug) {
      setSkills([]);
      setError(null);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const data = await fetchSkillsByCategorySlug(slug);
      setSkills(Array.isArray(data) ? data : data?.data || []);
    } catch (err) {
      setError(err.message);
      setSkills([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadSkills(categorySlug);
  }, [categorySlug, loadSkills]);

  return { skills, loading, error, setCategorySlug };
};

export default useSkillsByCategory;
